import { configureStore } from "@reduxjs/toolkit";
import { alertSlice } from "./features/alertSlice";
import { userSlice } from "./features/userSlice";
import { discountSlice } from "./features/discountSlice";
import { querySlice } from "./features/querySlice";
import footerMenuReducer from "./features/footerMenuSlice";
import { updateMobileSlice } from "./features/updateMobileSlice";
import dataReducer from "./features/dataSlice";

export default configureStore({
	reducer: {
		alerts: alertSlice.reducer,
		updateMobileModal: updateMobileSlice.reducer,
		user: userSlice.reducer,
		discount: discountSlice.reducer,
		query: querySlice.reducer,
		footerMenu: footerMenuReducer,
		data: dataReducer,
	},
});
